/**
 * 홀딩 상태 상수 정의
 */
class HoldingStatus {
    static REJECTED = 0;    // 거절
    static ACCEPTED = 1;    // 승인
    static PENDING = 2;     // 대기중
    static CANCELLED = 3;   // 취소

    /**
     * 상태 코드를 텍스트로 변환
     * @param {number} status - 상태 코드
     * @returns {string} 상태 텍스트
     */
    static getStatusText(status) {
        switch (status) {
            case this.REJECTED:
                return "거절";
            case this.ACCEPTED:
                return "승인";
            case this.PENDING:
                return "대기중";
            case this.CANCELLED:
                return "취소";
        }
    }

    /**
     * 상태 코드가 유효한지 확인
     * @param {number} status - 상태 코드
     * @returns {boolean} 유효성 여부
     */
    static isValid(status) {
        return status === this.REJECTED || 
               status === this.ACCEPTED || 
               status === this.PENDING;
    }

    /**
     * 상태에 따른 CSS 클래스명 반환
     * @param {number} status - 상태 코드
     * @returns {string} CSS 클래스명
     */
    static getStatusClass(status) {
        switch (status) {
            case this.REJECTED:
                return "holding-status-rejected";
            case this.ACCEPTED:
                return "holding-status-accepted";
            case this.PENDING:
                return "holding-status-pending";
            default:
                return "holding-status-unknown";
        }
    }
}

export default HoldingStatus; 